import { createSelector } from 'reselect';

import { TInitialState } from '~/src/entities/speed-bonus/context/reducer';

export const selectedRouter = createSelector(
    [
        (state: TInitialState) => state.routers,
    ],
    (routers) => routers.find(router => router.quantity),
);
